import bus from '@/service/EventBus'

export default class Loader {
  static show () {
    bus.$emit('loader', true)
  }
  static hide () {
    bus.$emit('loader', false)
  }
}



// WEBPACK FOOTER //
// ./src/service/Loader.js